import { memo, useEffect, useRef } from 'react';

import axios from 'api/axios';
import useNotification from 'hooks/useNotification';

/**
 * Loyiha aktivlik holatini har 5 daqiqada tekshiradi.
 * is_active === 1 (ochilmoqda) bo'lsa — "Dastur puli tugamoqda" ogohlantirishi.
 * (is_active === 0 da backend API'ni bloklaydi.)
 */
const ProjectStatusWatcher = () => {
  const sendNotification = useNotification();
  const timer = useRef(null);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await axios.get('/project-status');
        if (Number(res?.data?.is_active) === 1) {
          sendNotification({
            msg: 'Dastur puli tugamoqda. Iltimos, to\'lovni amalga oshiring.',
            variant: 'warning',
            duration: 10000,
          });
        }
      } catch (e) {
        // jim
      }
    };

    check();
    timer.current = setInterval(check, 5 * 60 * 1000);
    return () => clearInterval(timer.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default memo(ProjectStatusWatcher);
